export const team = [
  // Leadership
  {
    image: 'Danny Pikler.jpg',
    name: 'Daniel Pikler',
    role: 'Co-Founder',
    background:
      'After working as a musician, then as a geneticist at the CSIRO in Canberra, Danny studied secondary teaching in Melbourne and saw first-hand the need for better science teaching resources. Danny joined Byron and Alan to found Stile in 2012.',
    categories: ['leadership'],
  },
  {
    image: 'Jayde Taylor.jpg',
    name: 'Jayde Taylor',
    role: 'Chief Financial Officer',
    background:
      'Jayde was traveling in South America when she started to think differently about purpose. She had been working in New York and London for award-winning creative agencies, integrating new digital ventures for a rapidly changing market. In Stile she saw a unique opportunity to unlock the potential of young people with innovative content and technology.',
    categories: ['leadership'],
  },
  {
    image: 'Byron Scaf.jpg',
    name: 'Byron Scaf',
    role: 'Co-Founder',
    background: `Byron got a few months into a PhD in Neuroscience at Melbourne University before building Australia's first electric vehicle charging network with Better Place. Finally understanding what STEM meant in the real world, he co-founded Stile in 2012 and set about working with schools.`,
    categories: ['leadership'],
  },
  {
    image: 'Kat Gentry.jpg',
    name: 'Kat Gentry',
    role: 'Head of Stile USA',
    background:
      'Kat was a science teacher before researching pest management in aquaculture across Norway, Australia, and New Zealand. Striving to cultivate student curiosity, enhance teacher job satisfaction, and bring more science classrooms to life, Kat leads Stile’s US team.',
    categories: ['leadership', 'content', 'team-usa'],
  },
  {
    image: 'Daniel Rodgers-Pryor.jpg',
    name: 'Daniel Rodgers-Pryor',
    role: 'Chief Technology & Security Officer',
    background: `Daniel’s academic background in Condensed Matter Physics and Computer Science gave him a passion for promoting scientific literacy and the skills to manage complex computing systems. Daniel joined Stile in 2014 and stepped into the role of CTO in 2017.`,
    categories: ['leadership'],
  },
  {
    image: 'Jaclyn Rooney.jpg',
    name: 'Jaclyn Rooney',
    role: 'Head of Teaching and Learning',
    background:
      'Jaclyn is a dedicated educator, bringing a wealth of experience in teaching, curriculum design, and teacher professional learning in both science and physical education. She joined Stile in 2016 and is responsible for Professional Learning. She is passionate about supporting, celebrating and enhancing the amazing work that science teachers do to help make science learning not only impactful, but relevant and engaging for students.',
    categories: ['product', 'leadership'],
  },

  // Content
  {
    image: 'Campbell Edgar.jpg',
    name: 'Campbell Edgar',
    role: 'Science Curriculum Editor',
    background: '',
    categories: ['content'],
  },
  {
    image: 'Toni Cox.jpg',
    name: 'Toni Cox',
    role: 'Science Curriculum Manager',
    background: '',
    categories: ['content'],
  },
  {
    image: 'Hamish McCoy.jpg',
    name: 'Hamish McCoy',
    role: 'Science Curriculum Editor',
    background: '',
    categories: ['content'],
  },
  {
    image: 'Marcus Finlay.jpg',
    name: 'Marcus Finlay',
    role: 'Science Curriculum Writer',
    background: '',
    categories: ['content'],
  },
  {
    image: 'Mark Picardo.jpg',
    name: 'Mark Picardo',
    role: 'North Carolina Science Education Leader',
    background:
      "Mark is North Carolina's science education leader with experience as a teacher in elementary and special education settings and as a building administrator. Dedicated to empowering students with diverse needs, Mark brings expertise in differentiation and curriculum design to his work. He joined Stile Education to empower teachers with hands-on, standards-aligned tools that elevate science instruction and inspire students to think like scientists and engineers.",
    categories: ['team-usa'],
  },
  {
    image: 'Mark Mannion.jpg',
    name: 'Mark Mannion',
    role: 'Science Team Lead',
    background: '',
    categories: ['content'],
  },
  {
    image: 'Caitlyn Jones.jpg',
    name: 'Caitlyn Jones',
    role: 'Executive Assistant',
    background: '',
    categories: ['content'],
  },

  {
    image: 'Courtney Hicks.jpg',
    name: 'Courtney Hicks',
    role: 'North Carolina Science Education Leader',
    background: '',
    categories: ['team-usa'],
  },
  {
    image: 'Tim Brade.jpg',
    name: 'Tim Brade',
    role: 'Studio Manager',
    background: '',
    categories: ['content'],
  },
  {
    image: 'Dimity Hately.jpg',
    name: 'Dimity Hately',
    role: 'Marketing Operations Manager',
    background: '',
    categories: ['content'],
  },
  {
    image: 'Penny Creagh.jpg',
    name: 'Penelope Creagh',
    role: 'Science Curriculum Writer',
    background: '',
    categories: ['content'],
  },

  // Community
  {
    image: 'Chloe Marie.jpg',
    name: 'Chloe Marie',
    role: 'Professional Learning Leader ',
    background: '',
    categories: ['community', 'teaching-learning'],
  },
  {
    image: 'Elise Kovacs.jpg',
    name: 'Elise Kovacs',
    role: 'Head of Schools, NSW',
    background: '',
    categories: ['community', 'teaching-learning'],
  },
  {
    image: 'Dion Factor.jpg',
    name: 'Dion Factor',
    role: 'Head of Schools, International',
    background: '',
    categories: ['community', 'teaching-learning'],
  },
  {
    image: 'Meghan Fennessy.jpg',
    name: 'Meghan Fennessy',
    role: 'Operations Coordinator',
    background: 'I must confess, I am actually an English teacher.',
    categories: ['community', 'teaching-learning'],
  },
  {
    image: 'Steve Dornan.jpg',
    name: 'Steve Dornan',
    role: 'Head of Schools, WA',
    background: '',
    categories: ['community', 'teaching-learning'],
  },
  {
    image: 'Jules Ius.jpg',
    name: 'Jules Ius',
    role: 'Senior Teacher Happiness Specialist',
    background: 'I dish out happiness.',
    categories: ['community', 'happiness'],
  },
  {
    image: 'Paul Giardina.jpg',
    name: 'Paul Giardina',
    role: 'Senior Teacher Happiness Specialist',
    background: 'I dish out happiness.',
    categories: ['community', 'happiness'],
  },
  {
    image: 'Kelly Fernandez.jpg',
    name: 'Kelly Fernandez',
    role: 'Sales Operations Analyst',
    background: '',
    categories: ['community'],
  },
  {
    image: 'Katrina Don Paul.jpg',
    name: 'Katrina Don Paul',
    role: 'Customer Operations Officer',
    background: 'Teacher, Scientist, Mum, Netflix (not necessarily in that order...)',
    categories: ['community', 'teaching-learning', 'happiness'],
  },
  {
    image: 'Julianna Jimenez.jpg',
    name: 'Julianna Jimenez',
    role: 'Director of School and District Partnerships',
    background:
      'Julianna failed her HS science classes which led her to believe she was terrible at science. That changed during her 3rd year of community college where a science teacher inspired her new path of becoming a HS science teacher. She is passionate about making health and science education fun, relevant, and accessible to all.',
    categories: ['community', 'teaching-learning', 'team-usa'],
  },
  {
    image: 'Tom Grubb.jpg',
    name: 'Tom Grubb',
    role: 'Head of Schools, SA',
    background: '',
    categories: ['community'],
  },
  {
    image: 'Patty Luna.jpg',
    name: 'Patty Luna',
    role: 'Head of Schools, VIC',
    background: '',
    categories: ['community'],
  },
  {
    image: 'Stiele Hagens.jpg',
    name: 'Stiele Hagens',
    role: 'Operations Manager',
    background: '',
    categories: ['community'],
  },

  // Engineering
  {
    image: 'Rhys Walsh-Tindall.jpg',
    name: 'Rhys Walsh-Tindall',
    role: 'Support Engineer',
    background: '',
    categories: ['engineering'],
  },
  {
    image: 'Alex Finkel.jpg',
    name: 'Alex Finkel',
    role: 'Staff Software Engineer',
    background: `Fantasy/sci-fi nerd, ballroom/latin dancer, sometimes abuses apostrophe’s.`,
    categories: ['engineering', 'content', 'product'],
  },
  {
    image: 'Matt Hanlon.jpg',
    name: 'Matt Hanlon',
    role: 'Marketing Manager',
    background: `Matt is a former journalist, photo and video nerd, and marketing jack-of-all-trades. His science career may have peaked in fifth grade when he won his school science fair but he's remained as curious as ever. He loves being outdoors, making and eating good food, and reading about weather phenomena. Matt joined Stile Education because he believes in developing scientifically literate youth today to build a better future tomorrow.`,
    categories: ['marketing', 'team-usa'],
  },
  {
    image: 'Matt Needham.jpg',
    name: 'Matthew Needham',
    role: 'Business Systems Engineer',
    background: `“When one Matt just isn’t enough.”`,
    categories: ['engineering'],
  },
  {
    image: 'Jeff Parsons.jpg',
    name: `Jeff Parsons`,
    role: 'Senior Tooling Engineer',
    background: '.',
    categories: ['engineering'],
  },
  {
    image: 'Nick Spain.jpg',
    name: 'Nick Spain',
    role: 'Head of Platform Engineering',
    background: 'Prefers his graphs directed and acyclic.',
    categories: ['engineering'],
  },
  {
    image: 'Ben Taylor.jpg',
    name: 'Ben Taylor',
    role: 'Software Engineer Team Lead',
    background: '',
    categories: ['engineering'],
  },
  {
    image: 'Jordi Llosa.jpg',
    name: 'Jordi Llosa',
    role: 'Staff Product Engineer',
    background: '',
    categories: ['engineering'],
  },
  {
    image: 'Shannon Cole.jpg',
    name: 'Shannon Cole',
    role: 'Senior Software Engineer',
    background: '',
    categories: ['engineering'],
  },
  {
    image: 'Chelsea Page Saxton.jpg',
    name: 'Chelsea Page-Saxton',
    role: 'Executive Assistant',
    background: '',
    categories: ['engineering'],
  },
  {
    image: 'Mac Brown.jpg',
    name: 'Mackenzie Brown',
    role: 'AI Enablement Engineering Lead',
    background: '',
    categories: ['engineering'],
  },

  // Operations
  {
    image: 'Emily Cheng.jpg',
    name: 'Emily Cheng',
    role: 'Finance Manager',
    background: 'My happiness is debit = credit.',
    categories: ['operations'],
  },
  {
    image: 'Lilka Jones.jpg',
    name: 'Lilka Jones',
    role: 'Administrative Assistant',
    background:
      'Lily is a former elementary and preschool teacher. Her most valued memories with children have all taken place in nature or in the art studio. Lily is a creative problem solver and loves employing this skill in Team USA.',
    categories: ['operations', 'team-usa'],
  },
  {
    image: 'Gina DiBenedetto.jpg',
    name: 'Gina DiBenedetto',
    role: 'People & Culture Manager',
    background: '',
    categories: ['operations'],
  },
  {
    image: 'Makeila Reyes.jpg',
    name: 'Makeila Reyes',
    role: 'Senior People & Culture Business Partner',
    background: '',
    categories: ['operations'],
  },
  {
    image: 'Nicole Li.jpg',
    name: 'Nicole Li',
    role: 'Commercial Finance Partner',
    background: '',
    categories: ['operations'],
  },

  // Product

  {
    image: 'Gisela Beer.jpg',
    name: 'Gisela Beer',
    role: 'Senior Designer, Content Lead',
    background: '',
    categories: ['product', 'content'],
  },
  {
    image: 'Gemma Cameron.jpg',
    name: 'Gemma Cameron',
    role: 'Science Curriculum Writer',
    background: '',
    categories: ['product', 'content'],
  },
  {
    image: 'Sean Hurley.jpg',
    name: 'Sean Hurley',
    role: 'Head of Design',
    background: 'Can cook eggs at least 9 different ways.',
    categories: ['product', 'content'],
  },
  {
    image: 'Jack Brock.jpg',
    name: 'Jack Brock',
    role: 'Senior Product Designer',
    background: '',
    categories: ['product', 'content'],
  },
  {
    image: 'Pooja Prabhakaran.jpg',
    name: 'Pooja Prabhakaran',
    role: 'Illustrator',
    background: 'Probably doodling if not making plans to cancel plans.',
    categories: ['product', 'content'],
  },
  {
    image: 'Alex Russell.jpg',
    name: 'Alexandra Russell',
    role: 'Head of Marketing',
    background: 'Middle school teacher and fur baby mama.',
    categories: ['product'],
  },
  {
    image: 'Charli Posner.jpg',
    name: 'Charli Posner',
    role: 'Software Engineer',
    background: '',
    categories: ['staff'],
  },
  {
    image: 'Ed Bassett.jpg',
    name: 'Ed Bassett',
    role: 'Principal Software Engineer',
    background: '',
    categories: ['staff'],
  },
  {
    image: 'Ellen Grodahl.jpg',
    name: 'Ellen Grodahl',
    role: 'People & Culture Coordinator',
    background: '',
    categories: ['staff'],
  },
  {
    image: 'Georgia Cavanagh.jpg',
    name: 'Georgia Cavanagh',
    role: 'Senior Art Director, Brand',
    background: '',
    categories: ['staff'],
  },
  {
    image: 'Lachlan Goebel.jpg',
    name: 'Lachlan Goebel',
    role: 'Junior Software Engineer',
    background: '',
    categories: ['staff'],
  },
  {
    image: 'Eva Hreins.jpg',
    name: 'Eva Hreins',
    role: 'Science Curriculum Writer',
    background: '',
    categories: ['staff'],
  },
  {
    image: 'Kunal Madhav.jpg',
    name: 'Kunal Madhav',
    role: 'Builder',
    background: '',
    categories: ['staff'],
  },
  {
    image: 'Ally Macdonald.jpg',
    name: 'Ally Macdonald',
    role: 'Builder',
    background: '',
    categories: ['staff'],
  },
  {
    image: 'Don Buchanan.jpg',
    name: 'Don Buchanan',
    role: 'Builder',
    background: '',
    categories: ['staff'],
  },
  {
    image: 'Will Cohen.jpg',
    name: 'Will Cohen',
    role: 'Senior Software Engineer',
    background: '',
    categories: ['staff'],
  },
  {
    image: 'Duncan Bay.jpg',
    name: 'Duncan Bay',
    role: 'Senior Software Engineer',
    background: '',
    categories: ['staff'],
  },
  {
    image: 'Francis Martin.jpg',
    name: 'Francis Martin',
    role: 'Software Engineer',
    background: '',
    categories: ['staff'],
  },
  {
    image: 'Franklin Ross.jpg',
    name: 'Franklin Ross',
    role: 'Principal Software Engineer',
    background: '',
    categories: ['staff'],
  },
  {
    image: 'Stevie Valentine.jpg',
    name: 'Stevie Valentine',
    role: 'Teacher Happiness Specialist',
    background: '',
    categories: ['staff'],
  },
  {
    image: 'Ruth Gunaseelan.jpg',
    name: 'Ruth Gunaseelan',
    role: 'Science Curriculum Writer',
    background: '',
    categories: ['staff'],
  },
  {
    image: 'Jakub Riedl.jpg',
    name: 'Jakub Riedl',
    role: 'Builder',
    background: '',
    categories: ['staff'],
  },
];
